import React from 'react';
import styled from 'react-emotion';
import CategoryLink from '@jetshop/ui/CategoryLink';
import theme from '@jetshop/ui/utils/theme';

import Image from '@jetshop/ui/Image/Image';

const Container = styled('div')`
  display: flex;
  flex-flow: wrap;
  width: 100%;
  margin-bottom: 1rem;
`;

const Category = styled('div')`
  display: flex;
  align-items: stretch;
  margin-bottom: 5px;

  ${theme('above.lg')} {
    ${p => p.theme.calculateWidth(4, 3)}
  }

  ${theme('between.sm-lg')} {
    ${p => p.theme.calculateWidth(3, 3)}
  }

  ${theme('below.sm')} {
    ${p => p.theme.calculateWidth(2, 3)}
  }
`;

const ImageWrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  margin-bottom: 0.3rem;
`;

const CategoryImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const StyledCategoryLink = styled(CategoryLink)`
  display: flex;
  width: 100%;
  flex-grow: 1;
  flex-flow: column;
  text-decoration: none;
  /* padding: 0.3rem; */
`;

const CategoryName = styled('div')`
  flex-grow: 1;
  align-self: stretch;
  font-weight: bold;
  color: ${theme('colors.primary')};
`;

const imageSizes = [0.5, 0.5, 0.4, 0.3];

const SubCategories = ({ category }) => {
  if (
    category === undefined ||
    category.subcategories === undefined ||
    category.subcategories.length === 0
  ) {
    return null;
  }

  return (
    <Container>
      {category.subcategories.map(subCategory => {
        return (
          <Category key={subCategory.id}>
            <StyledCategoryLink category={subCategory}>
              <ImageWrapper>
                {subCategory.images[2] && (
                  <CategoryImage
                    src={subCategory.images[2].url}
                    alt={subCategory.images[2].alt || subCategory.name}
                    title={subCategory.images[2].title || subCategory.name}
                    sizes={imageSizes}
                    aspect={'12:7|7:12'}
                  />
                )}
              </ImageWrapper>
              <CategoryName>{subCategory.name}</CategoryName>
            </StyledCategoryLink>
          </Category>
        );
      })}
    </Container>
  );
};

export default SubCategories;
